import React from 'react';

import { Checkbox, Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { PayRateFormValues } from './DrawerPayRateForm';

const CREDIT_CONDITION = ' when their credit was deducted';

interface IIncludeAttendanceOptionsProps {
  form: UseFormReturnType<PayRateFormValues>;
  disabled: boolean;
  creditCondition: boolean;
  indent: boolean;
}

const getHelperText = (subject: string, selected: boolean, creditCondition: boolean): string => {
  if (!selected) return `${subject} will not be included in the payment calculation`;
  if (creditCondition) return `${subject} will be included in the payment calculation${CREDIT_CONDITION}`;
  return `${subject} will be included in the payment calculation`;
};

const IncludeAttendanceOptions = ({
  form,
  disabled,
  creditCondition,
  indent,
}: IIncludeAttendanceOptionsProps): JSX.Element => {
  const paddingLeft = indent ? 20 : 0;

  return (
    <>
      <Stack spacing={4} style={{ paddingTop: 20, paddingLeft }}>
        <Checkbox
          data-cy='includeNoShowsButton'
          {...form.getInputProps('payForNoShow')}
          label='Include No Shows'
          checked={form.getInputProps('payForNoShow').value ?? false}
          disabled={disabled}
        />
        <Text size='sm' color='dimmed'>
          {getHelperText('Athletes with no-show', form.values.payForNoShow, creditCondition)}
        </Text>
      </Stack>
      <Stack spacing={4} style={{ paddingLeft }}>
        <Checkbox
          data-cy='includeLateCancelsButton'
          {...form.getInputProps('payForLateCancel')}
          label='Include Late Cancels'
          checked={form.getInputProps('payForLateCancel').value ?? false}
          disabled={disabled}
        />
        <Text size='sm' color='dimmed'>
          {getHelperText('Athletes with late cancellation', form.values.payForLateCancel, creditCondition)}
        </Text>
      </Stack>
    </>
  );
};

export default IncludeAttendanceOptions;
